import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SyndicatesRouteGuard } from './syndicate.guard';
import { CashoutRouteGuard } from './cashout.guard';
import { FreeplayRouteGuard } from './freeplay.guard';
import { HomepageRouteGuard } from './homepage.guard';
import { NoContentRouteGuard } from './no-content.guard';
import { PoolsDefaultRouteGuard } from './poolsroute.guard';
import {TicketsRouteGuard} from "./tickets.guard";

export function provideGuards(): EnvironmentProviders {
  return makeEnvironmentProviders([
    SyndicatesRouteGuard,
    FreeplayRouteGuard,
    CashoutRouteGuard,
    HomepageRouteGuard,
    NoContentRouteGuard,
    PoolsDefaultRouteGuard,
    TicketsRouteGuard
  ]);
}
